/**
 * Route helpers for IT Ticketing, kept dependency-free so always-loaded shell
 * code (Header, CommandPalette, the XPM Agent panel) can ask "am I in IT
 * Ticketing?" without importing the module's services.
 */
const BASE_PATH = '/it-ticketing'

// Second path segments under /it-ticketing that are pages, not ticket ids
// (see ItTicketingRoutesProvider.tsx). Anything else in that slot is the
// `:ticketId` detail route.
const NON_TICKET_SEGMENTS = new Set(['reports', 'settings', 'history', 'admin', 'my-delegations'])

export function isItTicketingPath(pathname: string): boolean {
  return pathname === BASE_PATH || pathname.startsWith(`${BASE_PATH}/`)
}

/** The ticket id when the path is a ticket detail page, otherwise null. */
export function ticketIdFromPath(pathname: string): string | null {
  if (!isItTicketingPath(pathname)) return null
  const segment = pathname.slice(BASE_PATH.length + 1).split('/')[0] ?? ''
  if (!segment || NON_TICKET_SEGMENTS.has(segment)) return null
  return decodeURIComponent(segment)
}
